import { domClassMerge } from '@propertyfinder/helpers';
import { IconSpriteChevronDown } from '@propertyfinder/icons';
import { FunctionalComponent, h } from 'preact';

import { chooseAOrB } from 'common/helper/choose/a-or-b';
import { i18nTranslate } from 'common/helper/i18n/translate';
import { inputSelectCheckIfSelected } from 'common/helper/input/select/check-if-selected';
import { inputSelectProduceSelectedText } from 'common/helper/input/select/produce-selected-text';
import { DropdownTemplatePropsInterface } from 'common/module/dropdown/template-props.interface';
import { InputSelectOptionInterface } from 'common/module/input/select/option.interface';
import { Loader4Template } from 'common/module/loader/4/template';

export const DropdownTemplate: FunctionalComponent<
  DropdownTemplatePropsInterface & preact.JSX.DOMAttributes<HTMLDivElement>
> = (props) => {
  return (
    <div
      className={`dropdown ${props.class}
     ${props.isError ? props.errorClass : ''}
    `}
      onClick={props.onClickDropdown}
      onFocus={props.onFocus}
      onBlur={props.onBlur}
      tabIndex={0}
      role='button'
    >
      <div
        className={`
        dropdown__text
        ${props.valueClass}
        ${props.isDisabled ? 'dropdown__text--disabled' : ''}
      `}
      >
        {props.isNew && <span className='dropdown__notification-dot' />}
        {chooseAOrB(
          props.selectedElement,
          inputSelectProduceSelectedText(props.value, props.placeholder, props.options as InputSelectOptionInterface[])
        )(!!props.selectedElement)}
      </div>
      {!props.isLoading && (
        <IconSpriteChevronDown
          className={domClassMerge(
            'dropdown__icon',
            {
              'dropdown2__icon--active': !props.isOpen,
            },
            props.iconClass
          )}
        />
      )}
      {props.isLoading && (
        <div className='dropdown__loader'>
          <Loader4Template />
        </div>
      )}
      <div
        className={[
          'dropdown__popup',
          props.isOpen && 'dropdown__popup--opened',
          props.multiple && 'dropdown__popup--mulitple',
          props.optionsClass || '',
        ].join(' ')}
      >
        {props.multiple && (
          <div className='dropdown__item' onClick={(e) => props.onClickSelectAll(e)}>
            {i18nTranslate(
              props.value !== undefined && props.value.length === props.options.length ? 'Unselect all' : 'Select all'
            )}
          </div>
        )}
        {props.options.map((option: InputSelectOptionInterface) => (
          <div
            className={`dropdown__item ${
              inputSelectCheckIfSelected(props.value, option) || option.value === props.highlighted
                ? 'dropdown__item--selected'
                : ''
            }`}
            onMouseEnter={(e) => props.onMouseEnterOption(e, option)}
            onMouseLeave={(e) => props.onMouseLeaveOption(e, option)}
            onClick={(e) => props.onClickOption(e, option)}
          >
            {option.text}
          </div>
        ))}
      </div>
    </div>
  );
};
